
import './styles.css';

const About = () => {

    return (
        <div className="about">
            <p className="about-content">
                I am a full stack developer with a passion for building web applications. I have a strong background in
                front-end development and have worked with a wide range of technologies. This project is is about searching
                for games based on a user's input from a list of games fetched from an Api. The user can sort the games by
                their score, title, genre or platform. This is a complete responsive react application with subtle ui and
                animations.

                This project is built using React, Node, Express, MongoDB, and a variety of other technologies.
            </p>
        </div>
    )
}

export default About;